<app-details-page-header
  [title]="'Edit'"
  [subtitle]="projectName"
  [loading]="isLoading()"
  (back)="onBack()"
>
  <app-button
    [btnClass]="'btn btn-danger btn-sm d-flex align-items-center gap-2'"
    [iconClass]="'fas fa-times'"
    [label]="'admin.projectIdeas.actions.decline' | translate"
    [disabled]="isLoading() || isUpdating() || !canModerate()"
    [loading]="isUpdating()"
    [attr.title]="
      !canModerate()
        ? ('admin.projectIdeas.edit.toasts.moderationLocked' | translate)
        : null
    "
    (clicked)="decline()"
  />

  <app-button
    [btnClass]="'btn btn-success btn-sm d-flex align-items-center gap-2'"
    [iconClass]="'fas fa-check'"
    [label]="'admin.projectIdeas.actions.accept' | translate"
    [disabled]="isLoading() || isUpdating() || !canModerate()"
    [loading]="isUpdating()"
    [attr.title]="
      !canModerate()
        ? ('admin.projectIdeas.edit.toasts.moderationLocked' | translate)
        : null
    "
    (clicked)="accept()"
  />
</app-details-page-header>

<app-project-idea-base-wizard [project]="project()" />
